import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { MasterDataTab } from "../../../../companies/masterData/MasterDataTab";

export const Route = createFileRoute("/firmen/$companyId/stammdaten/")({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(trpc.getHubspotPortalId.queryOptions());
    void queryClient.ensureQueryData(
      trpc.companies.getCompanyNote.queryOptions({ companyId })
    );
  },
  component: StammdatenRoute,
});

function StammdatenRoute() {
  const { companyId } = Route.useParams();
  return (
    <Container>
      <MasterDataTab companyId={companyId} />
    </Container>
  );
}
